import Vue from 'vue';
import _ from 'lodash';
import { VGrid } from '@/types/Components';

const GridSearch = Vue.extend({
    data: () => ({
        searchText: '',
        searchTextDebounce: _.debounce((func) => func(), 500),
    }),
    methods: {
        onInputSearchText(): void {
            this.searchTextDebounce(() => {
                (this.$refs as { grid: VGrid<unknown> }).grid.load();
            });
        },
    }
});

export default GridSearch;
